<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("WithdrawalHistory") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="topfix">
      <div class="container lg">
        <div class="tophead text-center">
          <div class="col-xs-6">
            <router-link to="/alldeposit">
              <p class="pointer">
                {{ $t("DepositHistory") }}
              </p>
            </router-link>
          </div>
          <div class="col-xs-6 active">
            <router-link to="/allwithdraw">
              <p class="pointer">
                {{ $t("WithdrawalHistory") }}
              </p>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="topFilter">
      <div class="container lg">
        <div class="form-group">
          <label for="filter" class="sr-only">Filter</label>
          <input
            type="text"
            class="form-control filter"
            v-model="filter"
            placeholder="Search ..."
          />
        </div>
      </div>
    </div>

    <div class="loader-example" v-if="!ready">
      <div class="loader-bar"></div>
    </div>
    <div class="container-center lg animated fadeIn" v-else>
      <div v-if="table_rows.length == 0">
        <div class="container-center lg loader-example text-center">
          <i class="fad fa-search fa-4x"></i>
          <h4>You have no Withdrawal.</h4>
        </div>
      </div>
      <div v-else>
        <datatable
          :columns="logs_columns"
          :data="table_rows"
          :filter-by="filter"
        >
          <template slot-scope="{ row }">
            <tr
              class="pointer"
              v-on:click="
                expand(row._id);
                qrcode(row.address, row.amount);
              "
            >
              <td colspan="3">
                <span v-bind:class="'label ' + row.label">{{
                  row.status
                }}</span>
                <br />
                {{ row.createdAt }}
              </td>
              <td class="text-right" colspan="3">
                <span class="c-white font-bold m-r-sm">{{
                  (row.amount / 1).toFixed(8) / 1
                }}</span>
                <img
                  :src="require(`@/assets/tokens/${row.currency}.png`)"
                  class="coin"
                />
              </td>
            </tr>
            <tr class="table-expanded" v-if="expanded == row._id">
              <td colspan="3">
                <div class="animated fadeIn faster">
                  <p>
                    UserID:
                    <span class="c-white font-bold">
                      <router-link v-bind:to="'/user/' + row.user_id">
                        {{ row.user_id }}
                      </router-link>
                    </span>
                  </p>
                  <p>
                    <addresslink
                      :currency="row.currency"
                      :address="row.address"
                    ></addresslink>
                  </p>

                  <p v-if="row.status == 'COMPLETED'">
                    <txlink :currency="row.currency" :tx="row.tx_id"></txlink>
                  </p>
                  <p>
                    Fee:
                    <span class="c-white font-bold">
                      {{ row.fee }} {{ row.currency }}
                    </span>
                  </p>
                  <p v-if="row.status == 'PROCESSING'">
                    Audit By:
                    <span class="c-white font-bold">
                      <router-link v-bind:to="'/user/' + row.audit_by">
                        {{ row.audit_by }}
                      </router-link>
                    </span>
                  </p>
                  <p v-if="row.status == 'PROCESSING'">
                    <button
                      class="btn btn-xs btn-success text-success m-r-xs"
                      @click="update(row._id, 'COMPLETED')"
                    >
                      COMPLETED
                    </button>
                    <button
                      class="btn btn-xs btn-danger text-danger m-r-xs"
                      @click="update(row._id, 'REJECTED')"
                    >
                      REJECTED
                    </button>
                    <button
                      class="btn btn-xs btn-danger text-danger m-r-xs"
                      v-on:click="deletebox(row._id)"
                      v-if="row.status == 'PROCESSING'"
                    >
                      DELETE
                    </button>
                  </p>
                </div>
              </td>
              <td colspan="3">
                <p class="text-right">
                  <qrcode
                    v-model="qrcodescan"
                    :options="{ size: 200 }"
                    class="img-thumbnail"
                  ></qrcode>
                </p>
              </td>
            </tr>
          </template>
        </datatable>
        <div class="pager-footer">
          <datatable-pager
            v-model="page"
            type="abbreviated"
            :per-page="per_page"
            class="text-center"
          ></datatable-pager>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.topFilter {
  margin-top: 33px;
}
.active p {
  color: #f6a821;
  border-bottom-color: #f6a821;
  border-bottom: solid;
}
.container-center {
  margin-top: 93px;
  padding: 10px 0 100px 0;
}
.loader-example {
  margin-top: 200px;
}
.coin {
  width: 32px;
}
.table {
  word-wrap: break-word;
  table-layout: fixed;
}
</style>

<script>
import Vue from "vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";

Vue.component(VueQrcode.name, VueQrcode);

import admin from "@/api/admin";
import moment from "moment";
import func from "@/widgets/func";
import label from "@/widgets/label";
import nativeToast from "native-toast";

import addresslink from "@/components/addresslink";
import txlink from "@/components/txlink";

export default {
  components: {
    addresslink,
    txlink,
  },
  data() {
    return {
      qrcodescan: null,
      ready: false,
      filter: "",
      logs_columns: [
        { label: "", field: "createdAt", sortable: false },
        { label: "", field: "status", sortable: false },
        { label: "", field: "currency", sortable: false },
        { label: "", field: "amount", sortable: false },
        { label: "", field: "tx_id", sortable: false },
        { label: "", field: "address", sortable: false },
      ],
      table_rows: [],
      rows: window.rows,
      page: 1,
      per_page: 50,
      expanded: null,
    };
  },
  methods: {
    qrcode(address, amount) {
      this.qrcodescan = address + "?amount=" + amount.toFixed(6);
    },
    fixed(a) {
      return func.fixed(a);
    },
    getTableData() {
      this.table_rows = [];
      admin
        .allwithdraw()
        .then((response) => {
          this.ready = true;
          response.data.forEach((e) => {
            e.createdAt = moment(e.createdAt).format("YYYY-MM-DD, HH:mm:ss");

            var a = label.type(e.status);
            e.label = a.label;

            this.table_rows.push(e);
          });
        })
        .catch((error) => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error",
          });
        });
    },
    async deletebox(id) {
      if (confirm("Are you sure you want to delete?")) {
        await admin
          .deletewithdraw({
            _id: id,
          })
          .then(() => {
            this.getTableData();
            nativeToast({
              message: "Successfully.",
              position: "top",
              timeout: 3000,
              type: "success",
            });
          })
          .catch((err) => {
            this.getTableData();
            nativeToast({
              message: err.message,
              position: "top",
              timeout: 3000,
              type: "danger",
            });
          });
      }
    },
    async update(id, status) {
      this.ready = false;
      await admin
        .updatewithdraw({
          _id: id,
          status: status,
        })
        .then((res) => {
          this.ready = true;
          this.getTableData();
          nativeToast({
            message: res.data.message,
            position: "top",
            timeout: 3000,
            type: "success",
          });
        })
        .catch((error) => {
          this.ready = true;
          this.getTableData();
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error",
          });
        });
    },
    expand(id) {
      if (this.expanded == id) {
        this.expanded = null;
        return;
      }
      this.expanded = id;
    },
  },
  created() {
    this.getTableData();
  },
};
</script>
